import { render } from "./ParticipantCard.vue?vue&type=template&id=ab1cb5de&scoped=true"
import script from "./ParticipantCard.vue?vue&type=script&lang=js"
export * from "./ParticipantCard.vue?vue&type=script&lang=js"

import "./ParticipantCard.vue?vue&type=style&index=0&id=ab1cb5de&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab1cb5de"]])

export default __exports__